
$( document ).ready(function() { 
  $("#SingleOptionSelector-0").on("change",hgc_calc);   
  $("#Quantity").on("change",hgc_calc); 
  $(".product-form").on("submit",hgc_calc);
  hgc_calc();
});

function hgc_calc() {
  bonus_per = 20;//$20 free = 20, 
  price_ea = Number($('.product-price__price > span').html().replace(/[^0-9\.-]+/g,""));
  qty =  Number($("#Quantity").val());
  if (isNaN(qty)){qty = 1;}
  if (qty < 1){qty = 1;}
  if (isNaN(price_ea)){price_ea = 0;}
  subtotal = price_ea * qty;
  bonus = (subtotal - (subtotal % 50)) * (bonus_per/100);
  
  $('#span_hgc_subtotal').html('$'+subtotal);
  bonustext = '';
  if (bonus > 0){
    selectedval = $('#hgc_bonus_denopt').val();
    bonustext = 'Bonus Amount: $' + bonus;
    text1x='1 x $' + bonus;
	text20 = (bonus / bonus_per) + ' x $' + bonus_per;
    $('#hgc_bonus_denopt').find('option').remove();

    if (bonus > 30) {$('#hgc_bonus_denopt').append('<option value="' + text1x + '">'+ text1x +'</option>');}
    denom = [500,450,400,350,300,250,200,150,100,50];
    //denom = [500,300,275,250,225,200,175,150,125,100,75,50];
    //denom = [50,60,75,90,100,120,125,150,175,180,200,210,225,250,275,300,500];
    for (d in denom){
      damt = denom[d]
      if (bonus % damt == 0 && bonus != 0 && bonus != damt){
          dtext= bonus / damt + ' x $' + damt;
          $('#hgc_bonus_denopt').append($('<option>', {value: dtext,text: dtext}));
      }
    }
    $('#hgc_bonus_denopt').append('<option value="' + text20 + '">'+ text20 +'</option>').end().val(text20);

	$("#hgc_bonus_denopt option[value='"+selectedval+"']").attr("selected","selected");
    
    //if ( $('#hgc_bonus_denopt').find('option').length < 2){$('#span_hgc_denom').hide();} else {$('#span_hgc_denom').show()}
    
    $('#span_hgc_message').html(bonustext);    
  	//$('#span_hgc_opts').show(); // not needed for mannys black card 2026 jholm
    $('#hgc_bonus_denopt').attr('name','properties[Bonus Giftcard Denomination]');
	$('#20a').attr('name','properties[Bonus Giftcard Delivery]');
	$('#20b').attr('name','properties[Bonus Giftcard Delivery]');
  }
  else {
    bonustext = 'Order a gift card of $100 or more and get a bonus gift card!<br /><br />$20 bonus awarded for every $100 purchased.'
    $('#span_hgc_message').html(bonustext);
  	$('#span_hgc_opts').hide();
    $('#hgc_bonus_denopt').attr('name','unused_hgc_denopt');
	$('#20a').attr('name','unused_hgc_bonus_gc_delivery');
	$('#20b').attr('name','unused_hgc_bonus_gc_delivery');
  }

}

